import { render, staticRenderFns } from "./FilesystemWorkspace.vue?vue&type=template&id=4329224e&scoped=true&"
import script from "./FilesystemWorkspace.vue?vue&type=script&lang=ts&"
export * from "./FilesystemWorkspace.vue?vue&type=script&lang=ts&"
import style0 from "./FilesystemWorkspace.vue?vue&type=style&index=0&id=4329224e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4329224e",
  null
  
)

export default component.exports